export const ApplyRouting = [
  {
    path: "/purchase/apply/list",
    name: "purchase-apply-list",
    meta: { title: "采购申请" },
    notice: { type: "purchase_apply_examine", hasNotice: false },
    component: () =>
      import(/* webpackChunkName: "purchase-apply" */ "@/views/purchase/apply/list/index.vue"),
  },
  {
    hidden: true,
    path: "/purchase/apply/create",
    name: "purchase-apply-create",
    meta: { title: "新增采购申请", comName: "PurchaseApplyFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-apply" */ "@/views/purchase/apply/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/purchase/apply/flowPrint/:id",
    name: "purchase-apply-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-print" */ "@/views/purchase/apply/form-print/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/purchase/apply/edit/:id",
    name: "purchase-apply-edit",
    meta: { title: "编辑采购申请", comName: "PurchaseApplyFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-apply" */ "@/views/purchase/apply/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/purchase/apply/detail/:id",
    name: "purchase-apply-detail",
    meta: { title: "采购申请详情" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-apply" */ "@/views/purchase/apply/form-detail/index.vue"
      ),
  },
];
